import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from "../../services/apiUrls";
import {
  getAllDownloadsReport,
  saveAllDownloadsReport,
  sendEmailRequest,
} from "../slices";

export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
}

function* fetchAllDownloadedReports() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.DOWNLOADED_REPORTS.getAllDownloadedReports,
    });
    yield put(saveAllDownloadsReport(response));
  } catch (error) {
    console.log(error);
  }
}

function* postEmailRequest(actions?: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.DOWNLOADED_REPORTS.sendEmailRequest,
      data: actions.payload.payloadToSend,
    });
    actions.payload?.callback && actions.payload.callback(response);
  } catch (error) {
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(getAllDownloadsReport.type, fetchAllDownloadedReports);
  yield takeEvery(sendEmailRequest.type, postEmailRequest);
}
